/**
 * Controller for managing notifications.
 */

/**
 * @class InputMileageController
 * Initializes a new instance of the ChargeHasEndedController.
 */
function InputMileageController() {
    // Initialize the controller
    this.init.apply(this, arguments);
}

// Dependency injection for the controller
InputMileageController.$inject = ['$rootScope', 'MKioskService', '$message', '$Loading', 'ChargeRequestService', 'mdPanelRef', 'action'];


// Define the prototype methods for NotificationsCtrl
InputMileageController.prototype = {

    /** @type {DriverRequiredAction} */
    action: null,

    /** @type {number|null} */
    odometerReading: null,

    /** @type {boolean} */
    bypassValidationOfOdometerReading: false,

    /**
     * Initializes the controller with necessary services and scope.
     * @param {angular.IRootScopeService} $rootScope
     * @param {MKioskService} MKioskService
     * @param {$message} $message
     * @param {$Loading} $Loading
     * @param {ChargeRequestService} ChargeRequestService
     * @param {mdPanelRef} mdPanelRef
     * @param {DriverRequiredAction} action
     */
    init: function ($rootScope, MKioskService, $message, $Loading, ChargeRequestService, mdPanelRef, action) {
        this.$rootScope = $rootScope;
        this.MKioskService = MKioskService;
        this.$message = $message;
        this.$Loading = $Loading;
        this.chargeRequestService = ChargeRequestService;
        this.mdPanelRef = mdPanelRef;
        this.action = action;
    },


    /**
     * Saves the input mileage, handling specific errors with confirmation popups if necessary.
     */
    save() {
        this.$Loading.show();
        this.MKioskService.inputMileage({
            DriverRequiredActionId: this.action.Id,
            OdometerReading: this.odometerReading,
            BypassValidationOfOdometerReading: this.bypassValidationOfOdometerReading
        })
            .catch( (error)=>{
                this.$Loading.hide();
                return this.chargeRequestService.handleOdometerReadingError(error).then(()=>{
                    return this.MKioskService.inputMileage({
                        DriverRequiredActionId: this.action.Id,
                        OdometerReading: this.odometerReading,
                        BypassValidationOfOdometerReading: true
                    }).finally(this.$Loading.blockUI());
                });
            })
            .then(() => {
                this.$Loading.hide();
                this.close(true);
            });
    }
    
};


// Register the InputMileageController controller with the AngularJS module
angular.module('internal.home').controller('InputMileageController', InputMileageController);